import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Avatar, Button, List, ListItemButton, ListItemIcon, ListItemText, Typography, useTheme, } from '@mui/material';
import { useBooleanState } from 'shared/hooks/state/boolean';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { UniversalDialog } from 'console/dialogs/universal';
import { compressionByField } from 'utils';
import { ErrorBoundary } from 'shared/components/error-boundary';
const size = 46;
export const useFirmwareChangelogDialog = () => {
    const [opened, close, open] = useBooleanState(false);
    const FirmwareChangelogDialog = useMemo(() => {
        const FirmwareChangelogDialogComponent = ({ children, ...rest }) => {
            const { firmware_releases } = useAppSelector((state) => state.upgrade_soft);
            const theme = useTheme();
            return (_jsx(ErrorBoundary, { children: _jsx(UniversalDialog, { open: opened, onClose: close, title: "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0439 \u0432 \u0432\u0435\u0440\u0441\u0438\u044F\u0445 \u041F\u041E", footer: _jsx(Button, { variant: "contained", color: "primary", onClick: close, children: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C" }), children: _jsx(List, { sx: {
                            width: '100%',
                            maxHeight: '40vh',
                            overflowY: 'scroll',
                            mb: 2,
                            border: '1px solid #b8b5b2',
                        }, children: firmware_releases.changelogs
                            .filter((release) => release.changes !== '- ')
                            .sort(compressionByField('version'))
                            .reverse()
                            .map((changelog, index) => (_jsxs(ListItemButton, { children: [_jsx(ListItemIcon, { children: _jsx(Avatar, { style: {
                                            width: size,
                                            height: size,
                                            backgroundColor: theme.palette.primary.dark,
                                        }, children: changelog.version }) }), _jsx(ListItemText, { primary: changelog.changes
                                        .split('\n')
                                        .map((line) => line.replace(/^- /, '– '))
                                        .map((line, i) => (_jsx(Typography, { children: line }, i))) })] }, index))) }) }) }));
        };
        return FirmwareChangelogDialogComponent;
    }, [opened, close]);
    return [FirmwareChangelogDialog, open];
};
